import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import '@angular/forms';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function NgRatingBarComponent_ng_container_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 3);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("width", ctx_r3.halfValue, "%")("color", ctx_r3.colorActive)("padding", ctx_r3.styles.padding);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r3.symbol, ɵngcc0.ɵɵsanitizeHtml);
} }
const _c0 = function (a0) { return { "color": a0 }; };
function NgRatingBarComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 1);
    ɵngcc0.ɵɵlistener("mouseenter", function NgRatingBarComponent_ng_container_0_Template_span_mouseenter_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const i_r2 = restoredCtx.index; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.enter(i_r2); })("mouseleave", function NgRatingBarComponent_ng_container_0_Template_span_mouseleave_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const i_r2 = restoredCtx.index; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.leave(i_r2); })("click", function NgRatingBarComponent_ng_container_0_Template_span_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const i_r2 = restoredCtx.index; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.setSelected(i_r2); });
    ɵngcc0.ɵɵtemplate(2, NgRatingBarComponent_ng_container_0_span_2_Template, 1, 7, "span", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("font-size", ctx_r0.styles.fontSize)("background-color", ctx_r0.styles.backgroundColor)("margin-right", ctx_r0.styles.margin)("padding", ctx_r0.styles.padding);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(11, _c0, i_r2 <= ctx_r0.hoverIndex ? ctx_r0.colorActive : ctx_r0.colorDefault))("innerHTML", ctx_r0.symbol, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.isHovered && i_r2 == ctx_r0.halfIndex);
} }
class NgRatingBarComponent {
    constructor() {
        this.valueChange = new EventEmitter();
        this.hoverChange = new EventEmitter();
        this.symbol = '&#9733;';
        this.numbers = [];
        this.hoverIndex = -1;
        this.selectedValue = 0;
        this.halfValue = 0;
        this.halfIndex = -1;
        this.isHovered = false;
    }
    ngOnInit() {
        this.ratingCount = this.ratingCount || 5;
        this.colorActive = this.colorActive || '#edb867';
        this.colorDefault = this.colorDefault || '#d2d2d2';
        if (!this.styles) {
            this.styles = {
                fontSize: '28px',
                backgroundColor: '',
                margin: '5px',
                padding: '0'
            };
        }
    }
    ngOnChanges(changes) {
        if (changes.value || this.control) {
            this.initNumbers();
            this.calculateHalfValue();
        }
    }
    initNumbers() {
        this.numbers = Array(this.ratingCount)
            .fill(0)
            .map((x, i) => i);
        if (this.control) {
            this.selectedValue = this.control.value;
        }
        else {
            this.selectedValue = this.value;
        }
        this.hoverIndex = this.selectedValue - 1;
    }
    enter(i) {
        if (this.disabled) {
            return;
        }
        this.isHovered = true;
        this.hoverIndex = i;
        this.hoverChange.emit(1 + i);
    }
    leave(i) {
        if (this.disabled) {
            return;
        }
        this.isHovered = false;
        this.hoverIndex = this.selectedValue - 1;
    }
    setSelected(i) {
        if (this.disabled) {
            return;
        }
        // set/unset  selected value on same value click
        if (this.resetAble && this.selectedValue === i + 1) {
            this.selectedValue = 0;
        }
        else {
            this.selectedValue = i + 1;
        }
        if (this.control) {
            this.control.setValue(this.selectedValue || null);
            this.control.markAsTouched();
        }
        else {
            this.valueChange.emit(this.selectedValue);
        }
        this.isHovered = false;
        this.calculateHalfValue();
    }
    calculateHalfValue() {
        this.halfValue = Math.round(100 * (this.selectedValue - Math.floor(this.selectedValue)));
        this.halfIndex = Math.ceil(this.selectedValue) - 1;
    }
}
NgRatingBarComponent.ɵfac = function NgRatingBarComponent_Factory(t) { return new (t || NgRatingBarComponent)(); };
NgRatingBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgRatingBarComponent, selectors: [["ng-rating-bar"]], inputs: { symbol: "symbol", ratingCount: "ratingCount", colorActive: "colorActive", colorDefault: "colorDefault", styles: "styles", disabled: "disabled", resetAble: "resetAble", control: "control", value: "value" }, outputs: { valueChange: "valueChange", hoverChange: "hoverChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], [1, "star", 3, "ngStyle", "innerHTML", "mouseenter", "mouseleave", "click"], ["class", "star half", 3, "width", "color", "innerHTML", "padding", 4, "ngIf"], [1, "star", "half", 3, "innerHTML"]], template: function NgRatingBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NgRatingBarComponent_ng_container_0_Template, 3, 13, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.numbers);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgStyle, ɵngcc1.NgIf], styles: [".star[_ngcontent-%COMP%]{position:relative}.star[_ngcontent-%COMP%]:not(.half){min-height:20px;min-width:20px;cursor:pointer;display:inline-block}.star.active[_ngcontent-%COMP%]{color:inherit}.star.half[_ngcontent-%COMP%]{height:inherit;font-size:inherit;cursor:pointer;position:absolute;left:0;top:0;display:inline-block;overflow:hidden}"] });
NgRatingBarComponent.ctorParameters = () => [];
NgRatingBarComponent.propDecorators = {
    ratingCount: [{ type: Input }],
    colorActive: [{ type: Input }],
    colorDefault: [{ type: Input }],
    disabled: [{ type: Input }],
    resetAble: [{ type: Input }],
    control: [{ type: Input }],
    styles: [{ type: Input }],
    value: [{ type: Input }],
    valueChange: [{ type: Output }],
    hoverChange: [{ type: Output }],
    symbol: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgRatingBarComponent, [{
        type: Component,
        args: [{
                selector: 'ng-rating-bar',
                template: "<ng-container *ngFor=\"let item of numbers; let i = index\">\r\n  <span\r\n    class=\"star\"\r\n    (mouseenter)=\"enter(i)\"\r\n    (mouseleave)=\"leave(i)\"\r\n    (click)=\"setSelected(i)\"\r\n    [ngStyle]=\"{'color': (i <= hoverIndex) ? colorActive : colorDefault}\"\r\n    [style.fontSize]=\"styles.fontSize\"\r\n    [style.backgroundColor]=\"styles.backgroundColor\"\r\n    [style.marginRight]=\"styles.margin\"\r\n    [style.padding]=\"styles.padding\"\r\n    [innerHTML]=\"symbol\"\r\n  >\r\n  <span\r\n    class=\"star half\"\r\n    *ngIf=\"!isHovered && i == halfIndex\"\r\n    [style.width.%]=\"halfValue\"\r\n    [style.color]=\"colorActive\"\r\n    [innerHTML]=\"symbol\"\r\n    [style.padding]=\"styles.padding\"\r\n  >\r\n</span>\r\n</span>\r\n</ng-container>\r\n\r\n",
                styles: [".star{position:relative}.star:not(.half){min-height:20px;min-width:20px;cursor:pointer;display:inline-block}.star.active{color:inherit}.star.half{height:inherit;font-size:inherit;cursor:pointer;position:absolute;left:0;top:0;display:inline-block;overflow:hidden}"]
            }]
    }], function () { return []; }, { valueChange: [{
            type: Output
        }], hoverChange: [{
            type: Output
        }], symbol: [{
            type: Input
        }], ratingCount: [{
            type: Input
        }], colorActive: [{
            type: Input
        }], colorDefault: [{
            type: Input
        }], styles: [{
            type: Input
        }], disabled: [{
            type: Input
        }], resetAble: [{
            type: Input
        }], control: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();

class NgRatingBarModule {
}
NgRatingBarModule.ɵfac = function NgRatingBarModule_Factory(t) { return new (t || NgRatingBarModule)(); };
NgRatingBarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgRatingBarModule });
NgRatingBarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgRatingBarModule, [{
        type: NgModule,
        args: [{
                declarations: [NgRatingBarComponent],
                imports: [
                    CommonModule
                ],
                exports: [NgRatingBarComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgRatingBarModule, { declarations: function () { return [NgRatingBarComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgRatingBarComponent]; } }); })();

/*
 * Public API Surface of ng-rating-bar
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgRatingBarModule, NgRatingBarComponent as ɵa };

//# sourceMappingURL=ng-rating-bar.js.map